export const networkErrorMessages = {
    default: 'Please check your internet connection.',
};
